// ContactCard.js
import React from "react";
import { Card, CardContent, Typography, Button, Stack, Divider, Box } from "@mui/material";
import { Phone, Mail, Message } from "@mui/icons-material";
import SocialLinks from "./SocialLinks";

const ContactCard = ({ phone, email, social }) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const handleCall = () => {
    if (phone) {
      window.location.href = `tel:${phone}`;
    }
  };

  const handleEmail = () => {
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  };

  const handleWhatsApp = () => {
    if (!phone) return;
    const waAppUrl = `whatsapp://send?phone=${phone}`;
    const waWebUrl = `https://wa.me/${phone}`;

    if (isMobile) {
      window.location.href = waAppUrl;
      setTimeout(() => {
        window.open(waWebUrl, '_blank');
      }, 500);
    } else {
      window.open(waWebUrl, '_blank');
    }
  };

  const contactMethods = [
    { 
      icon: <Phone fontSize="small" />, 
      label: 'Call', 
      onClick: handleCall,
      disabled: !phone,
      variant: 'contained'
    },
    { 
      icon: <Mail fontSize="small" />, 
      label: 'Email', 
      onClick: handleEmail,
      disabled: !email,
      variant: 'outlined'
    },
    { 
      icon: <Message fontSize="small" />, 
      label: 'Message', 
      onClick: handleWhatsApp,
      disabled: !phone,
      variant: 'outlined'
    }
  ];

  return (
    <Card
      elevation={0}
      sx={{
        position: "sticky",
        top: 16,
        borderRadius: "4px",
        overflow: "hidden",
        backgroundColor: "#001d3d",
        border: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
      }}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#fff", fontSize: "1.1rem" }}>
          Contact Host
        </Typography>

        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" gutterBottom sx={{ color: "rgba(255,255,255,0.8)", fontSize: "0.85rem" }}>
            Connect via
          </Typography>
          <SocialLinks social={social} />
        </Box>

        <Divider sx={{ my: 2, borderColor: "rgba(255,255,255,0.2)" }} />

        <Stack spacing={1.5}>
          {contactMethods.map((method, index) => (
            <Button
              key={index}
              fullWidth
              variant={method.variant}
              startIcon={method.icon}
              onClick={method.onClick}
              disabled={method.disabled}
              sx={{
                py: 1.5,
                borderRadius: "4px",
                justifyContent: "flex-start",
                pl: 2,
                fontSize: "0.85rem",
                ...(method.variant === "contained"
                  ? { backgroundColor: "#fff", color: "#001d3d", "&:hover": { backgroundColor: "#e0e0e0" }, "&.Mui-disabled": { color: "rgba(255,255,255,0.5)", backgroundColor: "rgba(255,255,255,0.1)" } }
                  : { borderColor: "rgba(255,255,255,0.4)", color: "#fff", "&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.08)" }, "&.Mui-disabled": { borderColor: "rgba(255,255,255,0.2)", color: "rgba(255,255,255,0.4)" } }),
              }}
            >
              {method.label}
            </Button>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ContactCard;
